"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdateLandingPagesRequestStatus = exports.getLandingPagesByLanguageContentRequestStatus = exports.getLandingPagesByNameQueryRequestStatus = exports.getLandingPagesByIdsRequestStatus = exports.getLandingPagesByLanguageContent = exports.getLandingPagesByNameQueryAsSelectInputOptions = exports.getLandingPagesByNameQuery = exports.getLandingPageByIdAsSelectInputOption = exports.getLandingPageById = void 0;

var _immutable = require("immutable");

var _reselect = require("reselect");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _selectors = require("settings-ui-sdk/RequestStatuses/selectors");

var _actions = require("./actions");

var _constants = require("./constants");

var getLandingPages = function getLandingPages(state) {
  return state.modules.marketing.email.entities.landingPages;
};

var getLandingPagesByIds = (0, _reselect.createSelector)([getLandingPages], function (landingPages) {
  return landingPages.get('byId');
});
var getLandingPagesByNameQueries = (0, _reselect.createSelector)([getLandingPages], function (landingPages) {
  return landingPages.get('byNameQuery');
});
var getLandingPagesByLanguageContents = (0, _reselect.createSelector)([getLandingPages], function (landingPages) {
  return landingPages.get('byLanguage');
});

var getLandingPageById = function getLandingPageById(id) {
  return (0, _reselect.createSelector)([getLandingPagesByIds], function (landingPages) {
    return landingPages.get(id);
  });
};

exports.getLandingPageById = getLandingPageById;

var landingPageAsSelectInputOption = function landingPageAsSelectInputOption(landingPage) {
  return {
    text: landingPage.get(_constants.NAME),
    value: landingPage.get(_constants.ID)
  };
};

var getLandingPageByIdAsSelectInputOption = function getLandingPageByIdAsSelectInputOption(id) {
  return (0, _reselect.createSelector)([getLandingPageById(id)], function (landingPage) {
    return landingPage && landingPageAsSelectInputOption(landingPage);
  });
};

exports.getLandingPageByIdAsSelectInputOption = getLandingPageByIdAsSelectInputOption;

var getLandingPagesByNameQuery = function getLandingPagesByNameQuery(searchId) {
  return (0, _reselect.createSelector)([getLandingPagesByNameQueries], function (landingPages) {
    return landingPages.get(searchId);
  });
};

exports.getLandingPagesByNameQuery = getLandingPagesByNameQuery;

var getLandingPagesByNameQueryAsSelectInputOptions = function getLandingPagesByNameQueryAsSelectInputOptions(searchId) {
  return (0, _reselect.createSelector)([getLandingPagesByNameQuery(searchId)], function (landingPages) {
    if (!landingPages) {
      return [];
    }

    return landingPages.reduce(function (options, landingPage) {
      options.push(landingPageAsSelectInputOption(landingPage));
      return options;
    }, []);
  });
};

exports.getLandingPagesByNameQueryAsSelectInputOptions = getLandingPagesByNameQueryAsSelectInputOptions;

var getLandingPagesByLanguageContent = function getLandingPagesByLanguageContent(domain) {
  return (0, _reselect.createSelector)([getLandingPagesByLanguageContents], function (landingPages) {
    return landingPages.get(domain) || (0, _immutable.Map)();
  });
};

exports.getLandingPagesByLanguageContent = getLandingPagesByLanguageContent;

var getLandingPagesByIdsRequestStatus = function getLandingPagesByIdsRequestStatus(ids) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_IDS + "&ids=" + ids) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.getLandingPagesByIdsRequestStatus = getLandingPagesByIdsRequestStatus;

var getLandingPagesByNameQueryRequestStatus = function getLandingPagesByNameQueryRequestStatus(searchId) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_NAME_QUERY + "&searchId=" + searchId) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.getLandingPagesByNameQueryRequestStatus = getLandingPagesByNameQueryRequestStatus;

var getLandingPagesByLanguageContentRequestStatus = function getLandingPagesByLanguageContentRequestStatus(domain, languages) {
  return (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(_actions.LandingPagesActionTypes.FETCH_LANDING_PAGES_BY_LANGUAGE_CONTENT + "&domain=" + domain + "&language=" + languages.join(',')) || _RequestStatusTypes.default.UNINITIALIZED;
  });
};

exports.getLandingPagesByLanguageContentRequestStatus = getLandingPagesByLanguageContentRequestStatus;
var getUpdateLandingPagesRequestStatus = (0, _reselect.createSelector)([_selectors.getRequestStatuses], function (requestStatuses) {
  return requestStatuses.get(_actions.LandingPagesActionTypes.UPDATE_LANDING_PAGE) || _RequestStatusTypes.default.SUCCEEDED;
});
exports.getUpdateLandingPagesRequestStatus = getUpdateLandingPagesRequestStatus;